<template>
  <div class="ExpertCard">
    <div class="expert-cards-container">
      <div v-for="expert in experts" :key="expert.id" class="expert-card">
        <!-- Left Section: Photo and Experience -->
        <div class="expert-left">
          <img :src="serverHostName + '/' + expert.pic" class="expert-avatar" v-if="expert.pic" @click="goToExpertStore(expert)" />
          <!-- <img src="../assets/images/avatar.png" class="expert-avatar" v-else /> -->
          <div class="expert-initial-avatar" v-else>{{ initialName(expert.full_name) }}</div>

          <p class="expert-experience" v-if="expert.investment_experience && !isNaN(Number(expert.investment_experience))">
            Exp:
            <span class="experience">{{ Number(expert.investment_experience) > 1 ? Number(expert.investment_experience) + ' Year' : Number(expert.investment_experience) + ' Years' }}</span>
          </p>
        </div>

        <!-- Right Section: Details and Actions -->
        <div class="expert-right">
          <div class="expert-header">
            <span class="expert-name">{{ expert.full_name }}</span>
            <span class="expert-status" :class="expert.status == 'Busy' ? 'busy' : expert.status == 'Online' ? 'online' : ''">
              {{ expert.status ? expert.status : '' }}
            </span>
          </div>

          <p class="expert-sebi" v-if="expert.sebi_regi_number">SEBI NO. {{ expert.sebi_regi_number ? expert.sebi_regi_number : '' }}</p>

          <div class="expert-tag flex" v-if="expert.expert_skills && expert.expert_skills.length">
            <img src="../assets/images/ChatImages/Tags Icon (2).svg" alt="" />
            <span class="left-margin-5">{{ expert.expert_skills.join(', ') }}</span>
          </div>

          <div class="expert-languages">
            <div class="flex" v-if="expert.chat_language && expert.chat_language.length">
              <img src="../assets/images/ChatImages/Language Icon.svg" alt="" />
              <span class="left-margin-5">{{ expert.chat_language.join(', ') }}</span>
            </div>

            <el-button class="chat-btn disabled" v-if="expert.status == 'Busy' || expert.status == 'Offline'">
              <span class="chat-icon"></span>
              <span class="chat-txt">Chat</span>
            </el-button>

            <el-button class="chat-btn" @click="goToChat(expert)" v-if="expert.status == 'Online' || expert.status == 'Ongoing'" :disabled="hasOngoingSession && expert.status !== 'Ongoing'" :class="{ disabled: hasOngoingSession && expert.status !== 'Ongoing' }">
              <span class="chat-icon"></span>
              <span class="chat-txt">Chat</span>
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- <div id="video-section" class="video-popup-dialog-wrapper">
      <el-dialog :visible.sync="videoDialog" :before-close="videoDialogClose" center :close-on-click-modal="true" class="video-popup-dialog">
        <span class="custom-close-icon" @click="videoDialogClose">×</span>
        <div id="iframe-container" class="iframe-container">
          <iframe id="videoId" width="100%" height="320px" :src="videoUrl + '&mute=1'" title="YouTube video player" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </div>
      </el-dialog>
    </div> -->

    <!-- <div :class="['permanent-video-wrapper', { dimmed: videoDialog }]" v-if="!videoDialog && !isMobile">
      <iframe class="permanent-video-iframe" src="https://www.youtube.com/embed/gYBjuNrQP3U?autoplay=1&mute=1&rel=0&modestbranding=1" title="YouTube video" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div> -->
  </div>
</template>

<script>
import { serverHostName } from '../networkConfig';
import { HelperNetworkCallBack } from '../mixins/Helper';

export default {
  mixins: [HelperNetworkCallBack],

  props: ['experts'],

  data() {
    return {
      serverHostName: serverHostName,
      videoDialog: false,
      videoUrl: '',
      isMobile: window.innerWidth <= 768,
    };
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },

    videoDialogClose() {
      this.videoDialog = false;
      this.videoUrl = '';
    },
    goToExpertStore(expert) {
      this.$store.commit('commitExpertDetails', {});
      this.$router.push({
        path: '/expert-store',
        query: {
          user_id: expert.id,
          user: 'individual',
          name: expert.full_name,
        },
      });
    },

    goToChat(expert) {
      this.selectedExpertForChat = expert;

      if (Object.keys(this.getChatPlanDetails).length && this.getChatPlanDetails.remaining_chat_session >= 1) {
        if (expert.status === 'busy' || expert.status === 'Offline') {
          this.$emit('updateIsExpertBusyPopup', true);
        } else {
          this.$emit('updateIsStartChatPopup', this.selectedExpertForChat);
        }
      } else {
        this.$emit('updateChatPlanDetailsPopup', true);
        // this.videoUrl = 'https://www.youtube.com/embed/gYBjuNrQP3U?autoplay=1&rel=0&modestbranding=1';
        // this.videoDialog = true;
      }
    },
  },

  computed: {
    getChatPlanDetails() {
      return this.$store.state.chat_plan_details;
    },

    hasOngoingSession() {
      return this.experts.some((expert) => expert.status === 'Ongoing');
    },
  },
};
</script>

<style scoped lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.ExpertCard {
  .expert-cards-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .expert-card {
    display: flex;
    justify-content: space-between;
    border-radius: 10px;
    width: calc(50% - 10px);
    box-sizing: border-box;
    background: #ffff;
    box-shadow: 0px 0px 10px 0px #dfdddd;
    min-width: 430px;
    // margin: auto;

    &:hover {
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }
  }

  .expert-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100px;
    text-align: center;
    background-color: #d8eaff;
    padding: 10px;
    border-radius: 10px 0 0 10px;

    .expert-avatar {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      margin-bottom: 10px;
      object-fit: cover;
    }

    .expert-initial-avatar {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      margin-bottom: 10px;
      background-color: #4caf50;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 36px;
      font-weight: bold;
      text-transform: uppercase;
    }

    .expert-experience {
      font-size: 12px;
      color: #666;
    }

    p {
      margin: 0;
    }

    .experience {
      background-color: transparent;
      border: none;
      color: #2488ff;
      cursor: pointer;
      font-weight: 600;
      font-size: 11px;
    }
  }

  .expert-right {
    flex-grow: 1;
    padding: 15px 20px;
    width: 75%;

    .expert-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;
    }

    .expert-name {
      font-size: 13px;
    }

    .expert-status {
      font-size: 12px;
      color: $secondary-theme-color;
      font-weight: 500;
      text-transform: capitalize;

      &.online {
        color: $theme-green-color;
      }

      &.busy {
        color: $primary-theme-color;
      }
    }

    .expert-sebi {
      margin: 5px 0;
      font-size: 10px;
      color: #000;
      font-weight: 500;
    }

    .expert-tag {
      font-size: 11px;
      margin-bottom: 5px;
      color: $text-muted;
    }

    .expert-languages {
      font-size: 11px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 5px;
      color: $text-muted;

      .chat-btn {
        color: white;
        border: none;
        padding: 5px 13px;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        background: #ffff;
        color: $theme-green-color;
        border: 1px solid $theme-green-color;
        border-radius: 16px;
        font-weight: 600;
        margin-left: auto;

        &:hover {
          background-color: $theme-green-color;
          color: #ffff;
        }

        .chat-icon {
          width: 16px;
          height: 16px;
          margin-right: 5px;
          background-image: url('../assets/images/ChatImages/chatIconGreen.svg');
          background-size: cover;
          display: inline-block;
        }

        .chat-txt {
          position: relative;
          bottom: 3px;
        }

        &:hover .chat-icon {
          background-image: url('../assets/images/ChatImages/chatIconWhite.svg');
        }
      }

      .chat-btn.disabled {
        pointer-events: none;
        color: #ddd;
        border: 1px solid #ddd;
        opacity: 0.7;

        .chat-icon {
          background-image: url('../assets/images/ChatImages/chatIconGray.svg');
        }
      }
    }
  }
}

@media (max-width: 920px) {
  .ExpertCard {
    .expert-cards-container {
      justify-content: center;
    }

    .expert-card {
      width: 100%;
    }
  }
}

@media (max-width: 450px) {
  .ChatExpertList .expert-list-section {
    padding: 10px;
  }

  .ExpertCard .expert-left {
    width: 80px;
  }

  .ExpertCard .expert-card {
    min-width: auto;
  }

  .ExpertCard .expert-right {
    padding: 10px 12px;

    .expert-languages {
      flex-wrap: wrap;

      .chat-btn {
        margin-top: 5px;
        font-size: 12px;
        padding: 3px 7px;

        i {
          font-size: 15px !important;
        }
      }
    }

    .expert-tag,
    .expert-status,
    .expert-languages {
      font-size: 10px;

      img {
        width: 15px;
      }
    }
  }
}
</style>

<style lang="scss">
.ExpertCard {
  .video-popup-dialog-wrapper {
    #iframe-container {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .iframe-container iframe {
      width: 100%;
      height: 320px;
      border-radius: 8px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    }

    .el-dialog {
      border-radius: 10px;
      box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.3);
      max-width: 500px !important;
      width: 90vw;
      margin: 0 !important;

      // Position centered between left:240px and right end
      position: fixed;
      top: 22%;
      left: calc(240px + ((100vw - 240px) / 2) - (500px / 2));
      transform: translateY(-50%);
    }

    .custom-close-icon {
      position: absolute;
      top: 8px;
      right: 12px;
      font-size: 24px;
      color: #000;
      font-weight: bold;
      cursor: pointer;
      z-index: 9999;
      transition: color 0.2s ease;
    }

    .custom-close-icon:hover {
      color: #f44336;
    }

    @media (max-width: 1100px) {
      .el-dialog {
        left: 50% !important;
        // right: auto !important;
        transform: translate(-50%, -50%) !important;
      }
    }

    @media (max-width: 600px) {
      .iframe-container iframe {
        height: 220px;
      }

      .el-dialog {
        max-width: 95vw !important;
        top: 80px !important;
      }

      .custom-close-icon {
        font-size: 22px;
        top: 6px;
        right: 10px;
      }
    }
  }
  .permanent-video-wrapper {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 320px;
    height: 180px;
    z-index: 10;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    overflow: hidden;
    transition: opacity 0.3s ease;
  }

  .permanent-video-wrapper.dimmed {
    opacity: 0.3;
    pointer-events: none;
  }

  .permanent-video-iframe {
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 10px;
  }
}
</style>